<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <header>
      <div>
        <el-input
          placeholder="搜索名字/手机号"
          suffix-icon="el-icon-search"
          size="mini"
          @blur="searchFn"
          @clear="searchFn"
          v-model="formData.sceneName"
          clearable
          style="width: 180px; margin-right: 10px"
        >
        </el-input>
        <el-button-group>
          <span style="font-size: 14px;">导入时间:</span>
          <el-date-picker
            v-model="searchSelectTime"
            size="mini"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectTime"
            clearable
            style="width: 240px; margin-right: 10px"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-button-group>
        <el-button-group style="margin-right: 10px;">
          <span style="font-size: 14px;">分配状态:</span>
          <el-select
            v-model="formData.allocationStatus"
            @change="searchFn"
            @clear="searchFn"
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in allENUMOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group style="margin-right: 10px;">
          <span style="font-size: 14px;">添加状态:</span>
          <el-select
            v-model="formData.taskStatus"
            @change="searchFn"
            @clear="searchFn"
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in taskStatusENUMOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group style="margin-right: 10px;">
          <span style="font-size: 14px;">通过情况:</span>
          <el-select
            v-model="formData.approvalStatus"
            @change="searchFn"
            @clear="searchFn"
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in approvalENUMOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group style="margin-right: 10px;">
          <span style="font-size: 14px;">分配员工:</span>
          <el-select
            v-model="formData.empName"
            @change="searchFn"
            @clear="searchFn"
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in empNameList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-button-group>
      </div>
      <div style="margin-top: 20px;">
        <el-button size="mini" type="primary" @click="handleAllocation"
          >一键分配当前资源</el-button
        >
        <el-button size="mini" type="primary" @click="handleResources"
          >指定员工分配</el-button
        >
        <el-button size="mini" type="primary" @click="handleSetting"
          >设置</el-button
        >
        <el-button size="mini" type="primary" @click="handleFount"
          >创建</el-button
        >
        <el-button size="mini" type="primary" @click="handleImport"
          >导入</el-button
        >
      </div>
    </header>
    <div class="table-content">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 350px)"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="handleDisabled"
        >
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="cusPhone" label="手机号码" width="180">
        </el-table-column>
        <el-table-column prop="cusName" label="姓名" width="180">
        </el-table-column>

        <el-table-column prop="remark" label="备注信息" width="180">
        </el-table-column>

        <el-table-column prop="allocationStatus" label="分配状态">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            <el-tag
              :type="scope.row.allocationStatus === 1 ? 'success' : 'danger'"
              size="mini"
            >
              {{ allENUM[scope.row.allocationStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="taskStatus" label="添加状态">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            <el-tag
              v-if="scope.row.taskStatus === 1"
              type="success"
              size="mini"
            >
              {{ taskStatusENUM[scope.row.taskStatus] }}
            </el-tag>
            <el-tag
              v-else-if="scope.row.taskStatus === 0"
              type="danger"
              size="mini"
            >
              {{ taskStatusENUM[scope.row.taskStatus] }}
            </el-tag>
            <el-tag v-else :type="'warning'" size="mini">
              {{ taskStatusENUM[scope.row.taskStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="empName" label="分配员工"> </el-table-column>
        <el-table-column prop="approvalStatus" label="通过情况">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            <el-tag
              :type="scope.row.approvalStatus === 1 ? 'success' : 'danger'"
              size="mini"
            >
              {{ approvalENUM[scope.row.approvalStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作">
          <template slot-scope="scope">
            <a
              style="color: #409eff;cursor: pointer;"
              @click="handleEditRemark(scope.row)"
              >编辑备注</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
    <Fount ref="fount" @upload="getDataList"></Fount>
    <AllocateResources
      ref="resources"
      @upload="getDataList"
    ></AllocateResources>
    <SetDialog ref="set"></SetDialog>
    <ImportExcel
      ref="excel"
      :dialogVisiImport.sync="dialogVisiImport"
      @uploadSuccess="uploadSuccess"
    ></ImportExcel>
  </div>
</template>

<script>
// getFriendTask
import {
  getFriendTask,
  postAllocation,
  getEmpData,
} from "../../../api/addFriends/addFriends.js";
import Fount from "./components/fount.vue";
// 分配员工资源
import AllocateResources from "./components/allocateResources.vue";
// 设置
import SetDialog from "./components/setDialog.vue";
// 导入导出
import ImportExcel from "./components/importExcel.vue";
import dayjs from "dayjs";
export default {
  name: "customerResources",
  data() {
    return {
      formData: {
        id: "",
        sceneName: "",
        startTime: "",
        endTime: "",
        allocationStatus: "",
        taskStatus: "",
        approvalStatus: "",
      },
      searchSelectTime: [],
      tableData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageSizes: [10, 20, 50, 100, 200, 500],
      multipleSelection: [],
      empNameList: [],
      allENUM: {
        0: "未分配",
        1: "已分配",
      },
      taskStatusENUM: {
        0: "未添加",
        1: "已添加",
        2: "报告为空号",
      },
      approvalENUM: {
        0: "未通过",
        1: "已通过",
      },
      allENUMOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未分配",
          value: 0,
        },
        {
          label: "已分配",
          value: 1,
        },
      ],
      taskStatusENUMOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未添加",
          value: 0,
        },
        {
          label: "已添加",
          value: 1,
        },
        {
          label: "报告为空号",
          value: 2,
        },
      ],
      approvalENUMOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未通过",
          value: 0,
        },
        {
          label: "已通过",
          value: 1,
        },
      ],
      dialogVisiImport: false,
    };
  },
  components: { Fount, AllocateResources, SetDialog, ImportExcel },
  created() {
    this.getDataList();
    this.handleGetEmpData();
  },
  methods: {
    async handleGetEmpData() {
      const res = await getEmpData(localStorage.getItem("Authorization"));
      if (res.error.code == 200) {
        res.data.forEach((item) => {
          if (item) {
            this.empNameList.push(item);
          }
        });
      }
    },
    handleDisabled(row, rowIndex) {
      if (row.taskStatus == 2) {
        return false;
      } else {
        return true;
      }
    },
    // 增加不可选底色
    tableRowClassName({ row, rowIndex }) {
      if (row.taskStatus == 2) {
        return "warning-row";
      } else {
        return "";
      }
    },
    // 导入
    handleImport() {
      this.dialogVisiImport = true;
      this.$refs.excel.init();
    },
    // 设置
    handleSetting() {
      this.$refs.set.dialogVisible = true;
      this.$refs.set.title = "设置";
      this.$refs.set.getData();
    },
    // 编辑
    handleEditRemark(val) {
      console.log("编辑备注", val);
      this.$refs.fount.dialogVisible = true;
      this.$refs.fount.title = "编辑备注";
      this.$refs.fount.type = "edit";
      this.$refs.fount.form = {
        id: val.id,
        cusPhone: val.cusPhone,
        cusName: val.cusName,
        remark: val.remark,
      };
    },
    handleClick() {},
    async getDataList() {
      this.multipleSelection = [];
      const res = await getFriendTask(
        {
          param: this.formData.sceneName,
          current: this.pageparm.currentPage,
          size: this.pageparm.pageSize,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
          allocationStatus: this.formData.allocationStatus,
          taskStatus: this.formData.taskStatus,
          approvalStatus: this.formData.approvalStatus,
          empName: this.formData.empName,
        },
        localStorage.getItem("Authorization")
      );
      console.log("请求数据XXXX表格", res);
      this.tableData = res.data.result;
      this.pageparm.total = res.data.total;
    },
    // 商品名称搜索
    searchFn() {
      this.pageparm.currentPage = 1;
      this.getDataList();
    },
    // 时间处理
    selectTime(dataTime) {
      if (dataTime == null) {
        this.formData.startTime = "";
        this.formData.endTime = "";
      } else {
        // this.formData.startTime = dataTime[0];
        // this.formData.endTime = dataTime[1];
        this.formData.startTime = dayjs(dataTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        this.formData.endTime = dayjs(dataTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      this.formData.pageNum = 1;
      this.getDataList();
    },
    // 分页回调
    callBack(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getDataList();
    },
    // 创建
    handleFount() {
      this.$refs.fount.dialogVisible = true;
      this.$refs.fount.title = "创建客户";
      this.$refs.fount.type = "add";
      this.$refs.fount.form = {
        id: "",
        cusPhone: "",
        cusName: "",
        remark: "",
      };
    },
    // 指定员工分配
    handleResources() {
      if (this.multipleSelection.length <= 0) {
        return this.$message.warning("请至少选择一项");
      }
      this.$refs.resources.dialogVisible = true;
      this.$refs.resources.checkList = this.multipleSelection;
      this.$refs.resources.searchMenNames = [];
      this.$refs.resources.currentSelectMember = [];
      this.$refs.resources.taskIdList = [];
      this.$refs.resources.userList = [];
    },
    handleSelectionChange(val) {
      console.log("选择------", val);
      this.multipleSelection = val;
    },
    async handleAllocation() {
      if (this.multipleSelection.length <= 0) {
        return this.$message.warning("请至少选择一项");
      } else {
        let dataList = [];
        this.multipleSelection.forEach((item) => {
          dataList.push(item.id);
        });
        let res = await postAllocation(
          { taskId: dataList, user: [] },
          localStorage.getItem("Authorization")
        );
        if (res.error.code == 200) {
          this.$message.success("设置成功");
          console.log("查看一键分配任务情况XXX", res);
          this.multipleSelection = [];
          this.getDataList();
        } else {
          this.$message.warning("设置失败");
        }
      }
    },
    /** 上传成功子组件通知父组件刷新页面 */
    uploadSuccess() {
         this.getDataList();
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table .warning-row {
  background: #eee;
}

/deep/.el-table .success-row {
  background: #eee;
}
</style>
